import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { glassmorphism } from 'styles/core/gradients';

export const Wrapper = styled.header`
  padding: ${rem('20px')} 0;
  ${glassmorphism};
  position: fixed;
  top: 0;
  width: 100%;
  transition: all 0.3s ease-in-out;
  z-index: 100;

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    ${({ $isMenuOpen, theme }) =>
      $isMenuOpen &&
      css`
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background-color: ${theme.colors.bodyBg};
      `};
  }

  @media ${({ theme }) => theme.mediaQueries.smallMax} {
    padding: ${rem('20px')} 0;
  }

  ${({ $sticky }) =>
    $sticky &&
    css`
      background: rgba(255, 255, 255, 0.95);
      backdrop-filter: blur(20px);
      -webkit-backdrop-filter: blur(20px);
      border-bottom: 1px solid rgba(255, 255, 255, 0.2);
      box-shadow: 0 8px 32px 0 rgba(31, 38, 135, 0.3);
    `};

  ${({ $darkPage, $sticky }) =>
    $darkPage &&
    !$sticky &&
    css`
      background: rgba(255, 255, 255, 0.9);
      backdrop-filter: blur(12px);
      -webkit-backdrop-filter: blur(12px);
    `};
`;

export const HeaderContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr auto auto;
  column-gap: ${rem('48px')};
  align-items: center;
  color: ${({ theme }) => theme.colors.textPrimary};

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    grid-template-columns: 1fr auto 1fr;
    place-items: center;
    color: ${({ $isMenuOpen, theme }) =>
      $isMenuOpen && theme.colors.colorTextBody};
  }
`;

export const BrandContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  /* Add logo animations */
  @keyframes logoGlow {
    0%,
    100% {
      filter: drop-shadow(0 2px 4px rgba(124, 58, 237, 0.2))
        drop-shadow(0 0 8px rgba(124, 58, 237, 0.1));
    }
    50% {
      filter: drop-shadow(0 2px 6px rgba(124, 58, 237, 0.3))
        drop-shadow(0 0 12px rgba(124, 58, 237, 0.2))
        drop-shadow(0 0 20px rgba(124, 58, 237, 0.1));
    }
  }

  @keyframes accentPulse {
    0%,
    100% {
      opacity: 0.7;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.1);
    }
  }

  svg {
    margin-right: 10px;
    display: block;
    animation: logoGlow 3s ease-in-out infinite;
    transition: filter 0.3s ease;
  }

  &:hover svg {
    filter: drop-shadow(0 4px 8px rgba(124, 58, 237, 0.4))
      drop-shadow(0 0 16px rgba(124, 58, 237, 0.3))
      drop-shadow(0 0 24px rgba(124, 58, 237, 0.2)) !important;
    animation-play-state: paused;
  }

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    svg {
      margin-right: 0;
    }
  }
`;

// LogoStyles removed - now handled directly in BrandContainer

export const BrandTextContainer = styled.div`
  display: flex;
  flex-direction: column;

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    display: none;
  }
`;

export const Brand = styled.div`
  font-family: 'Righteous';
  font-size: ${rem('20px')};
  font-weight: 700;
  line-height: 1.2;
`;

export const Tagline = styled.div`
  font-size: ${rem('12px')};
  color: #374151;
  font-weight: 600;
  letter-spacing: 0.3px;
  margin-top: ${rem('2px')};
`;

export const NavTopBar = styled.div`
  display: flex;
  gap: ${rem('32px')};
  align-items: center;

  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    display: none;
  }
`;

export const NavSideBar = styled.div`
  margin-top: ${rem('100px')};
  display: grid;
  place-items: center;

  @media ${({ theme }) => theme.mediaQueries.large} {
    display: none;
  }
`;

export const ButtonStyles = css`
  padding: ${rem('10px')} ${rem('32px')};
  background: linear-gradient(
    135deg,
    ${({ theme }) => theme.colors.gradientStart} 0%,
    ${({ theme }) => theme.colors.gradientEnd} 100%
  );
  font-weight: 700;
  border-radius: 12px;
  line-height: ${rem('24px')};
  color: ${({ theme }) => theme.colors.white};
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.3),
      transparent
    );
    transition: left 0.6s ease;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 15px 0 rgba(124, 58, 237, 0.3);
  }

  &:hover::before {
    left: 100%;
  }
`;

export const MenuButtonStyles = css`
  font-size: ${rem('24px')};
  display: none;
  @media ${({ theme }) => theme.mediaQueries.largeMax} {
    display: flex;
    justify-self: flex-start;
  }
`;
